import { render, staticRenderFns } from "./BoardEditor.vue?vue&type=template&id=7c59a6e1&"
import script from "./BoardEditor.vue?vue&type=script&lang=js&"
export * from "./BoardEditor.vue?vue&type=script&lang=js&"
import style0 from "./BoardEditor.vue?vue&type=style&index=0&id=7c59a6e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports